import { getSchoolAnalysis, getSchoolAnalysisParams } from 'src/api/Admin'

export interface SchoolAnalysiseData{
    school_id: number,
    school_name: string,
    wide_loc: string,
    city_loc: string,
    total_student_count: number,
    participation_count: number,
    attendee_count: number,
    interested_count: number,
    apply_count: number,
    commissioned_count: number,
    not_interested_count: number
}

export const LoadSchoolAnalysis = async (params:getSchoolAnalysisParams)=>{
    const response = await getSchoolAnalysis(params)
    
    return {
        data: response.data as SchoolAnalysiseData[],
        totalPage: response.total_pages,
    };
}